import styled from 'styled-components';
import DateComponent from 'react-datepicker';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;

  .timestamp-info {
    display: flex;
    flex-direction: row;
    align-items: center;

    button {
      margin: 0;
      padding: 0;
      font-size: 14px;
      text-decoration: underline;
    }
  }

  .form-group {
    margin-top: 8px;
    display: flex;
    flex-direction: row;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .timestamp-select {
    margin-top: 8px;
  }
`;

export const DatePicker = styled(DateComponent)`
  border: 1px solid #ced4da;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    right 0.75rem center/8px 10px no-repeat;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  appearance: none;
`;
